'use client'

import { useEffect } from 'react'
import { useRouter, usePathname } from 'next/navigation'


// List of non-mobile-friendly routes
const NON_MOBILE_FRIENDLY_ROUTES = [
    //  '/cr/[slug]/featured',
     //'/cr/[slug]/portfolios',
    // '/registration',
    //'/subscription-received',
    // '/terms-of-use',
    '/testimonial',
    // '/testimonial/profile-setting'
    // '/dashboard'
]


export function MobileResponsivenessCheck() {

  const router = useRouter()
  const pathname = usePathname()

  useEffect(() => {
    const checkMobileResponsiveness = () => {
      // More comprehensive mobile device detection
      const isMobile = () => {
        // Check screen width
        const screenWidth = window.innerWidth

        // Check user agent
       // const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

        // Check if browser's device mode is mobile
        const isDeviceModeMobile = window.matchMedia("(max-width: 768px)").matches

        // Comprehensive mobile check
        return screenWidth <= 900 || 
            //    isMobileUserAgent || 
               isDeviceModeMobile
      }

      // Check if current route is non-mobile-friendly
      const isNonMobileFriendlyRoute = NON_MOBILE_FRIENDLY_ROUTES.some(route => {
        const pattern = new RegExp('^' + route.replace(/\[.*?\]/g, '[^/]+') + '$');
        return pattern.test(pathname);
      });

      // Redirect if needed
      if (isMobile() && isNonMobileFriendlyRoute) {
        router.push('/mobile-responsive')
      }
    }

    // Check on initial load and window resize
    checkMobileResponsiveness()
    window.addEventListener('resize', checkMobileResponsiveness)

    return () => {
      window.removeEventListener('resize', checkMobileResponsiveness)
    }
  }, [pathname, router])

  return null
}